import { MultipleEnabledBanner, useCanShowMultipleEnabledBanner } from '@occc/ui-notifications';

export const MultipleOptionsBanner = () => {
  return useCanShowMultipleEnabledBanner() ? <MultipleEnabledBanner p={3} pt={0} /> : null;
};
